import colours from '../../../../Common/DesignSystem/Colours';

// used to add styles to DesignSystem components
export const textStyles = {
	displayName: { color: colours.primary.grey01, maxWidth: '223px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
	identification: { color: colours.primary.grey01 },
	serialNumber: { margin: '0 12px 0 5px' },
	deviceStatus: { color: colours.primary.grey02 },
	missingData: { color: colours.primary.grey02, marginLeft: '5px' },
	fleet: { color: colours.primary.grey01, display: 'flex', alignItems: 'center', maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
	unrelatedDevicesTitle: { margin: '18px 8px 10px' },
}